export const modalName = "ux-iws-nb-contact-modal";
